'use client';

import React, { useEffect } from 'react';
import { Widget } from '@minswap/aggregator-widget';

import '@minswap/aggregator-widget/index.css';


export interface WidgetComponentProps {
  type: string;
  defaultAsset?: string | null;
}

export const WidgetComponent = ({ type, defaultAsset }: WidgetComponentProps) => {
  // Apply custom theme for Minswap widget
  useEffect(() => {
    if (type === 'MinswapWidget') {
      document.documentElement.setAttribute('data-ms-theme', 'default-dark');
    }

    return () => {
      document.documentElement.removeAttribute('data-ms-theme');
    };
  }, [type]);

  if (type !== 'MinswapWidget') {
    return null;
  }

  return (
    <div className="[&_button]:!rounded-button-md w-fit">
      <Widget
        displayMode="button"
        defaultAsset={defaultAsset ?? undefined}
      />
    </div>
  );
};
